import { v4 } from "uuid";
export const general = {
  raise_query: 0,
  required: false,
  display_visuals_line: 0
}

export const note = {
  message_note: ''
}
export const input_text = {
  default_val: "",
  restrict_number: "",
  restrict_spl_char: "",
  restrict_email: "",
  max_limit: "",
  max_limit_range: "",
  min_limit: "",
  min_limit_range: ""
}

export const toggle = {
  toggle_msg_1: "",
  toggle_msg_2: "",
  display_visuals_line:"",
  default_msg: ""
}

export const input_number = {
  default_val: "",
  measurement_unit: "",
  positive_number: false,
  whole_number: false,
  restrict_text: false,
  decimal_notation: false,
  decimal_notation_places: "",
  scientific_notation: false,
  scientific_exponent_notation: "",
  max_limit: false,
  max_limit_range: "",
  min_limit: false,
  min_limit_range: ""
}

export const input_email = {
  email_allowed: false
}

export const input_current_time = {
  time_format: "",
  time_display_format: ""
}

export const input_date = {
  date_display_format: ""
}

export const input_date_and_time = {
  time_format: "",
  time_display_format: "",
  date_display_format: ""
}

export const linked_field = {
  section: "",
  linked_field: "",
  default_val: ""
}

export const LinkedFieldSchema = {
  linked_field: {
    template_id: "",
    template_version: "",
    section_uuid: "",
    linked_field: "",
    default_val: 0,
  },
};

export const hyperlink = {
  name: "",
  url: ""
}

export const barcode = {
  format: "",
  linked_field: "",
  default_val: ""
}

export const file_upload = {
  allow_pdf_file_only: "",
  allow_other_file_format: "",
  allow_multi_upload: "",
  multi_upload_limit: "",
  size_per_file: "",
  file_size_unit: ""
}

export const image_upload={
  allow_jpg_only: "",
  allow_other_format:"",
  allow_multi_upload: "",
  multi_upload_limit:"",
  size_per_file: "",
  file_size_unit: "",
  image_dimension:""
}
// @info other schema of secondary form
export const DropdownSchema = {
  options: [
  ],
  default_val: '',
}

export const ConditionSchema = () => ({
  target_input_field_uuid: "",
  option_uuid: ""
});

export const ConditionsSchema = {
  conditions: [ConditionSchema()],
};

export const InputVariableSchema = () => ({
  name: "",
  linked_field_uuid: '',
  default_val: null
});

export const ReferenceVariableSchema = {
  input_calculation_variables: [InputVariableSchema()],
};

export const ValidationSchema = {
 validation_type_id:'',
 regex_pattern:'',
 message:''
}
export const RadioSchema = {
  options: [
    {
      value: '',
      label: ''
    }
  ],
  // default_val: '',
}

export const fieldTypeDefaults = {
  'Label': { general, note },
  'Toggle': { general, note, toggle },
  'Input Text': { general, note, input_text },
  'Input Radio': { general, note },
  'Input Dropdown': { general, note },
  'Input Number': { general, note, input_number },
  'Input Email': { general, note, input_email },
  'Input Current Time': { general, note, input_current_time },
  'Input Date': { general, note, input_date },
  'Input Date and Time': { general, note, input_date_and_time },
  'Linked Field': { general, note },
  'Hyperlink': { general, note, hyperlink },
  'File Upload': { general, note, file_upload },
  'Image Upload': { general, note, image_upload },

};
export const FieldSchema = {
  input_uuid: v4(),
  label: "Untitled field",
  placeholder: "Enter field title",
  order: 1,
  property: {
    field_layout: 12,
    field_type: "Input Text",
    general,
    note,
    input_text
  }
}

export const SectionSchema = {
  section_uuid: v4(),
  name: 'Untitled section',
  description: 'Enter section title',
  order: 1,
  property: {
    display_details: true,
    display_field_number: false,
  },
  fields: [FieldSchema]
}
